// @core/api/endpoints/task/get_task_policy_by_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskPolicyResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Get entity task policy
 * Returns the task policy directly attached to the specified entity (if any). Does NOT resolve inheritance — use ResolveTaskContext for that.
 */
export async function GetTaskPolicyByEntity(
  entity_type: string,
  entity_id: string,
  options?: RequestOptions
): Promise<TaskPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:entity_type/:entity_id/policy`;
  requestPath = requestPath.replace(':entity_type', encodeURIComponent(entity_type));
  requestPath = requestPath.replace(':entity_id', encodeURIComponent(entity_id));
  const requestOptions = options;
  return client.get<TaskPolicyResponse>(requestPath, { ...requestOptions });
}
